/**
 * React context for the current avatar-page section index (0 = intro,
 * 1 = skills, 2 = contact). Shared between the R3F canvas and DOM
 * overlay, so all layers stay in sync on scroll/click.
 */
import React, { createContext, useContext, useState } from "react";

type SectionContextValue = {
  section: number;
  setSection: (value: number) => void;
};

const SectionContext = createContext<SectionContextValue | undefined>(undefined);

export const SectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [section, setSection] = useState(0);
  return (
    <SectionContext.Provider value={{ section, setSection }}>
      {children}
    </SectionContext.Provider>
  );
};

export const useSection = () => {
  const ctx = useContext(SectionContext);
  if (!ctx) {
    throw new Error("useSection must be used within a SectionProvider");
  }
  return ctx;
};